/**
 * Escape closes the theme's `<details>` dropdowns (currency picker, sort menu).
 *
 * Clicking away is handled in CSS, by a full-screen layer on the open toggle; this adds the
 * keyboard half and hands focus back to the toggle. A module runs once per URL, so loading it
 * from several places adds one listener.
 */
// `toggle` does not bubble, so listen in the capture phase. On open, bring the current country
// into view inside the list (United Kingdom sits at the bottom of an alphabetical list).
document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.oudh-currency')) return;

    const panel = details.querySelector('.oudh-currency__panel');
    const current = details.querySelector('.is-current');
    if (panel instanceof HTMLElement && current instanceof HTMLElement) {
      const offset = current.getBoundingClientRect().top - panel.getBoundingClientRect().top;
      panel.scrollTop += offset - panel.clientHeight / 2 + current.offsetHeight / 2;
    }
  },
  true
);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  for (const details of document.querySelectorAll('details.oudh-currency[open], details.oudh-sort[open]')) {
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  }
});
